import '.a{display:grid;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import { useState } from 'react'
import Column from '@app/components/layout/Column'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { SocialMediaButton } from '@app/components/blocks/modal/SocialMediaButton'
import { Button } from '@app/components/core/button/Button'
import { faLink, faEnvelope } from '@fortawesome/pro-regular-svg-icons'
import {
  faXTwitter,
  faFacebook,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { useTranslations } from '@i18n/useLanguage'
import useMediaQuery from '@app/util/useMediaQuery'

type Props = {
  eventTitle: string
  eventUrl: string
}

export const SuccessStep = ({ eventTitle, eventUrl }: Props) => {
  const t = useTranslations().app.dashboard.event.creation
  const tShare = useTranslations().app.share
  const [copySuccess, setCopySuccess] = useState(false)
  const isMobile = useMediaQuery()

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(eventUrl)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch(() => {})
  }

  const handleEmailShare = () => {
    const subject = encodeURIComponent(eventTitle)
    const body = encodeURIComponent(eventUrl)
    window.open(`mailto:?subject=${subject}&body=${body}`)
  }

  const handleXShare = () => {
    const text = encodeURIComponent(eventTitle)
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(eventUrl)}`,
    )
  }

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`,
    )
  }

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`${eventTitle} - ${eventUrl}`)
    window.open(`https://wa.me/?text=${text}`)
  }

  return (
    <Column
      alignItems="center"
      gap="2rem"
      style={{
        justifyContent: 'center',
        textAlign: 'center',
        paddingBlock: '4rem',
      }}
    >
      <Column alignItems="center" gap="0.75rem" style={{ flex: 0 }}>
        <Title.H2>{t.successTitle}</Title.H2>
        <Text.Medium style={{ maxWidth: '36rem' }}>
          {t.successSubtext}
        </Text.Medium>
      </Column>

      <div className="a c"
        style={{
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(5, 1fr)',}}
      >
        <SocialMediaButton
          icon={faEnvelope}
          label={tShare.email}
          onClick={handleEmailShare}
        />
        <SocialMediaButton
          icon={faXTwitter}
          label={tShare.x}
          onClick={handleXShare}
        />
        <SocialMediaButton
          icon={faFacebook}
          label={tShare.facebook}
          onClick={handleFacebookShare}
        />
        <SocialMediaButton
          icon={faWhatsapp}
          label={tShare.whatsapp}
          onClick={handleWhatsAppShare}
        />
        <SocialMediaButton
          icon={faLink}
          label={copySuccess ? tShare.copiedLink : tShare.copyLink}
          onClick={handleCopyLink}
        />
      </div>

      <Button variant="primary" label={t.viewEvent} to={eventUrl} />
    </Column>
  )
}
